/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Facets Icon component.
 */
export const FacetsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 7L20 7" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7 12L17 12" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M10 17L14 17" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
};
